// Copyright 2025, University of Maryland, All Rights Reserved
import { memo } from 'react'
import { RefreshCw } from 'lucide-react'

import { BaseNode } from '@/subsystems/pipelines'

export const MarylandConnectorSyncWorkflowNode = memo(() => (
  <BaseNode
    icon={<RefreshCw />}
    label="Maryland Connector Sync"
    hasInput
  />
))

MarylandConnectorSyncWorkflowNode.displayName = 'MarylandConnectorSyncWorkflowNode'
